import { useEffect, useState } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Search, Plus, Pencil, CheckCircle2, Trash2, XCircle, Eye, Download, Printer, FileText, Clock } from 'lucide-react'
import { Modal, ConfirmModal } from '../../common/Modal/Modal'
import Select, { Pagination } from '../../common/Select/Select'
/* NEW: shared helpers + Template 2 (aa banne files Invoice.jsx ni bajuma j rakho) */
import { SELLER, r2, inr, calc, inWords, code128, QrMock } from './invoiceShared'
import { SupadaaInvoiceSheet, SupadaaLabelSheet, SD_CSS } from './SupadaaInvoiceSheet'

/* ═══════════════════════════════════════════════════════════
   API
   NOTE: tamara baki admin pages jevo j base url / token vapro.
   Jo tamari pase already api helper hoy to `api()` function
   ni jagya e e j vapri lo.
═══════════════════════════════════════════════════════════ */
const API_BASE = "https://supadaa.com/api"

/* admin login pachi token je key ma save thay te automatic shodhe */
function getToken() {
  const keys = ['token', 'admin_token', 'adminToken', 'authToken', 'auth_token', 'access_token', 'accessToken']
  for (const k of keys) {
    const v = localStorage.getItem(k) || sessionStorage.getItem(k)
    if (v) return v.replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '')
  }
  // jo object tarike save hoy (jem ke 'admin' ke 'user' ma {token: '...'})
  for (let i = 0; i < localStorage.length; i++) {
    try {
      const o = JSON.parse(localStorage.getItem(localStorage.key(i)))
      if (o && typeof o === 'object' && o.token) return o.token
    } catch (e) { /* json nathi */ }
  }
  return ''
}

async function api(path, body) {
  const token = getToken()
  const res = await fetch(API_BASE + path, {
    method: body === undefined ? 'GET' : 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok || json.status === false) {
    const first = json.errors ? Object.values(json.errors)[0]?.[0] : ''
    throw new Error(json.message || first || 'Request failed')
  }
  return json
}

/* ═══════════════════════════════════════════════════════════
   STATIC CONFIG  (footer notes — change as you need)
   SELLER details have moved to invoiceShared.jsx
═══════════════════════════════════════════════════════════ */
const FOOTER_NOTES = [
  '*ASSPL-Amazon Seller Services Pvt. Ltd., ARIPL-Amazon Retail India Pvt. Ltd. (only where Amazon Retail India Pvt. Ltd. fulfillment center is co-located)',
  'Customers desirous of availing input GST credit are requested to create a Business account and purchase on Amazon.in/business from Business eligible offers',
  'Please note that this invoice is not a demand for payment',
]

const STATE_LIST = [
  'Andhra Pradesh', 'Chhattisgarh', 'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Karnataka',
  'Maharashtra', 'Rajasthan', 'Tamil Nadu', 'Telangana', 'Uttar Pradesh', 'West Bengal',
]

/* custom Select na options */
const STATE_OPTIONS = STATE_LIST.map(s => ({ value: s, label: s }))

/* 0% add karyu: product ma 0% (Exempt) hoy to invoice ma pan set thay */
const GST_OPTIONS = [
  { value: '0', label: '0% (Exempt)' },
  { value: '5', label: '5%' },
  { value: '12', label: '12%' },
  { value: '18', label: '18%' },
  { value: '28', label: '28%' },
]

const PAY_OPTIONS = [
  { value: '', label: '— None / COD —' },
  { value: 'UPI', label: 'UPI' },
  { value: 'Credit Card', label: 'Credit Card' },
  { value: 'Debit Card', label: 'Debit Card' },
  { value: 'Net Banking', label: 'Net Banking' },
]

const STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'pending', label: 'Pending' },
  { value: 'paid', label: 'Paid' },
  { value: 'overdue', label: 'Overdue' },
]

const FILTER_STATUS_OPTIONS = [{ value: '', label: 'All Status' }, ...STATUS_OPTIONS]

/* ── NEW: invoice templates ── */
const TEMPLATE_OPTIONS = [
  { value: '1', label: 'Template 1 — Shipping Label + Tax Invoice' },
  { value: '2', label: 'Template 2 — Supadaa Tax Invoice' },
]
const TEMPLATE_KEY = 'invoice_template'
const readTemplate = () => {
  try {
    const v = localStorage.getItem(TEMPLATE_KEY)
    return v === '2' ? '2' : '1'
  } catch (e) { return '1' }
}

const STATUS_META = {
  paid: { color: '#10B981', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.30)', label: 'Paid', Icon: CheckCircle2 },
  pending: { color: '#F59E0B', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.30)', label: 'Pending', Icon: Clock },
  overdue: { color: '#EF4444', bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.30)', label: 'Overdue', Icon: XCircle },
  draft: { color: '#6366F1', bg: 'rgba(99,102,241,0.12)', border: 'rgba(99,102,241,0.30)', label: 'Draft', Icon: FileText },
}

/* ═══════════════════════════════════════════════════════════
   HELPERS
═══════════════════════════════════════════════════════════ */
const today = () => new Date().toISOString().split('T')[0]

/** form (flat) -> API payload */
const toPayload = (f, active) => ({
  ...(active ? { id: active.db_id } : {}),
  invoice_no: f.id.trim(),
  order_no: f.orderNo.trim(),
  status: f.status,
  invoice_date: f.date,
  customer: f.customer.trim(),
  phone: (f.phone || '').trim(),
  address: f.addr.trim(),
  city: f.city.trim(),
  pin: f.pin.trim(),
  state: f.state,
  gstin: f.gstin.trim(),
  description: f.desc,
  hsn: f.hsn,
  unit_price: f.unitPrice,
  qty: f.qty,
  discount: f.discount,
  tax_rate: f.taxRate,
  shipping_charge: f.shippingCharge || 0,
  pay_mode: f.payMode,
  weight: f.weight,
  item_type: f.itemType,
  /* order select karyo hoy to link (fakt create ma) */
  ...(active ? {} : { order_item_id: f.orderItemId || null }),
})

/* invoice no / order no khali rakho -> server random banavse */
const blankForm = () => ({
  id: '', orderNo: '', orderItemId: '', productId: '', status: 'draft', date: today(), customer: '', phone: '', addr: '', city: '', pin: '',
  state: 'Gujarat', gstin: '', desc: '', hsn: '3924', unitPrice: '', qty: '1', discount: '0', taxRate: '5', shippingCharge: '0', payMode: '', weight: '0.25', itemType: 'GENERAL',
})

/* ═══════════════════════════════════════════════════════════
   TEMPLATE 1 — INVOICE SHEET  (modal preview + print + PDF)
═══════════════════════════════════════════════════════════ */
const KV = ({ k, v }) => <div><b>{k}</b> {v}</div>
const Stack = ({ a, b }) => <div className="ai-stack"><span>{a}</span><span>{b}</span></div>

const Logo = () => (
  <div className="ai-logo">
    <span className="ai-logo-t">amazon<i>.in</i></span>
    <svg width="92" height="18" viewBox="0 0 92 18" fill="none" aria-hidden="true">
      <path d="M3 3 C30 19 62 19 86 5" stroke="#FF9900" strokeWidth="3.4" strokeLinecap="round" />
      <path d="M87 3 L78 4 M87 3 L84 12" stroke="#FF9900" strokeWidth="3" strokeLinecap="round" />
    </svg>
  </div>
)

const Signature = () => (
  <svg width="120" height="40" viewBox="0 0 140 48" fill="none" aria-hidden="true" style={{ opacity: 0.55 }}>
    <path d="M8 36 C14 20,22 14,28 18 C34 22,30 34,36 30 C42 26,44 16,52 20 C58 24,54 36,62 28 C68 22,72 12,80 16 C88 20,84 34,92 26 C98 20,104 14,112 18 C118 22,116 32,124 28 C128 26,130 22,134 20"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

function InvoiceSheet({ inv }) {
  const c = calc(inv)
  const cols = c.hasDiscount ? 10 : 9

  return (
    <div className="ai-sheet">
      {/* Header */}
      <div className="ai-head">
        <Logo />
        <div className="ai-title"><b>Tax Invoice/Bill of Supply/Cash Memo</b><span>(Triplicate for Supplier)</span></div>
      </div>

      {/* Parties */}
      <div className="ai-parties">
        <div className="ai-col">
          <div className="ai-blk">
            <b>Sold By :</b>
            <div>{SELLER.name}</div>
            <div>*</div>
            <div className="ai-gap" />
            {SELLER.lines.map(l => <div key={l}>{l}</div>)}
          </div>
          <div className="ai-blk">
            <KV k="PAN No:" v={SELLER.pan} />
            <KV k="GST Registration No:" v={SELLER.gst} />
            {inv.qr && <><b>Dynamic QR Code:</b><div><QrMock seed={inv.id} /></div></>}
          </div>
          <div className="ai-blk">
            <KV k="Order Number:" v={inv.orderNo} />
            <KV k="Order Date:" v={inv.orderDate} />
          </div>
        </div>

        <div className="ai-col ai-right">
          <div className="ai-blk">
            <b>Billing Address :</b>
            {inv.billing.lines.map((l, i) => <div key={i}>{l}</div>)}
            {inv.billing.gst && <KV k="GST Registration No:" v={inv.billing.gst} />}
            <KV k="State/UT Code:" v={inv.billing.code} />
          </div>
          <div className="ai-blk">
            <b>Shipping Address :</b>
            {inv.shipping.lines.map((l, i) => <div key={i}>{l}</div>)}
            <KV k="State/UT Code:" v={inv.shipping.code} />
            {inv.shipping.gst && <KV k="GST Registration No:" v={inv.shipping.gst} />}
            <KV k="Place of supply:" v={inv.supply} />
            <KV k="Place of delivery:" v={inv.delivery} />
          </div>
          <div className="ai-blk">
            <KV k="Invoice Number :" v={inv.id} />
            <KV k="Invoice Details :" v={SELLER.details} />
            <KV k="Invoice Date :" v={inv.date} />
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="ai-table-wrap">
        <table className="ai-table">
          <thead>
            <tr>
              <th>Sl. No</th><th className="ai-desc">Description</th><th>Unit Price</th>
              {c.hasDiscount && <th>Discount</th>}
              <th>Qty</th><th>Net Amount</th><th>Tax Rate</th><th>Tax Type</th><th>Tax Amount</th><th>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {c.rows.map((r, i) => {
              const split = r.taxType === 'CGST/SGST'
              const half = r2(r.tax / 2)
              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td className="ai-desc">{r.desc}<div>HSN:{r.hsn}</div></td>
                  <td className="num">{inr(r.unitPrice)}</td>
                  {c.hasDiscount && <td className="num">{r.discount > 0 ? '-' + inr(r.discount) : '—'}</td>}
                  <td className="num">{r.qty}</td>
                  <td className="num">{inr(r.net)}</td>
                  <td>{split ? <Stack a={`${r.taxRate / 2}%`} b={`${r.taxRate / 2}%`} /> : `${r.taxRate}%`}</td>
                  <td>{split ? <Stack a="CGST" b="SGST" /> : 'IGST'}</td>
                  <td className="num">{split ? <Stack a={inr(half)} b={inr(half)} /> : inr(r.tax)}</td>
                  <td className="num">{inr(r.total)}</td>
                </tr>
              )
            })}
            <tr className="ai-total">
              <td colSpan={cols - 2}>TOTAL:</td>
              <td className="num">{inr(c.tax)}</td>
              <td className="num">{inr(c.total)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Words + signature */}
      <div className="ai-box">
        <div className="ai-words"><b>Amount in Words:</b><b>{inWords(c.total)}</b></div>
        <div className="ai-sign">
          <b>For {SELLER.name}:</b>
          <Signature />
          <b>Authorized Signatory</b>
        </div>
      </div>

      <div className="ai-rcm">Whether tax is payable under reverse charge - No</div>

      {/* Payment */}
      {inv.payment && (
        <div className="ai-pay">
          <div><b>Payment Transaction ID:</b><br />{inv.payment.txnId}</div>
          <div><b>Date &amp; Time:</b> {inv.payment.dateTime}</div>
          <div><b>Invoice Value:</b><br />{c.total.toFixed(2)}</div>
          <div><b>Mode of Payment:</b> {inv.payment.mode}</div>
        </div>
      )}

      {/* Footer */}
      <div className="ai-footer">
        {FOOTER_NOTES.map(t => <div key={t}>{t}</div>)}
        <div className="ai-page">Page 1 of 1</div>
      </div>
    </div>
  )
}

/* ═══════════════════════════════════════════════════════════
   TEMPLATE 1 — PAGE 1 SHIPPING LABEL  (SVG, 920×1301 ≈ A4)
═══════════════════════════════════════════════════════════ */
const K = 0.82 // condensed look
const Tx = ({ x, y, s = 22, a = 'start', fill, rot, children }) => {
  const st = fill ? { fill } : undefined
  if (rot) return <g transform={`translate(${x} ${y}) rotate(-90) scale(${K} 1)`}><text x="0" y="0" fontSize={s} textAnchor={a} style={st}>{children}</text></g>
  return <text x={x / K} y={y} transform={`scale(${K} 1)`} fontSize={s} textAnchor={a} style={st}>{children}</text>
}

/* decorative placeholder DataMatrix — swap with bwip-js for real codes */
const DMock = ({ x, y, size, seed, ink }) => {
  const n = 18, c = size / n
  let h = 11
  for (const ch of seed) h = (h * 31 + ch.charCodeAt(0)) >>> 0
  const cells = []
  for (let j = 0; j < n; j++) for (let i = 0; i < n; i++) {
    let on
    if (i === 0 || j === n - 1) on = true
    else if (j === 0) on = i % 2 === 0
    else if (i === n - 1) on = j % 2 === 1
    else { h = (h * 1103515245 + 12345) >>> 0; on = ((h >>> 16) & 1) === 1 }
    if (on) cells.push(<rect key={`${i}-${j}`} x={x + i * c} y={y + j * c} width={c + 0.4} height={c + 0.4} />)
  }
  return <g fill={ink}>{cells}</g>
}

/* text ne fix width ma wrap kare (SVG ma auto wrap nathi) */
const wrapText = (text, maxW, s = 22) => {
  const maxChars = Math.max(8, Math.floor(maxW / (s * 0.52 * K)))
  const out = []
  let cur = ''
  for (let w of String(text ?? '').split(/\s+/).filter(Boolean)) {
    while (w.length > maxChars) { // bahu lambo single word hoy to todi nakho
      if (cur) { out.push(cur); cur = '' }
      out.push(w.slice(0, maxChars))
      w = w.slice(maxChars)
    }
    if ((cur + ' ' + w).trim().length > maxChars) { out.push(cur); cur = w }
    else cur = (cur + ' ' + w).trim()
  }
  if (cur) out.push(cur)
  return out.length ? out : ['']
}

/* text box ma fit thay te mate font size automatic ghatade (caps/digits mate) */
const fit = (txt, availW, s) => Math.min(s, availW / (String(txt ?? '').length * 0.78 * K))

function LabelSheet({ inv, ink = 'currentColor', paper = 'var(--ai-bg)' }) {
  const L = inv.label
  if (!L) return null
  const bc = code128(L.awb)
  const mw = 355 / bc.total
  const sort = L.sort || L.station
  const shipDate = L.shipDate || '28/07/2026'
  const [dd, mm, yy] = shipDate.split('/')
  const box = (x, y, w, h, sw = 3.5, fill = 'none') => <rect x={x} y={y} width={w} height={h} fill={fill} stroke={ink} strokeWidth={sw} />
  const hl = y => <line x1="77" x2="880" y1={y} y2={y} stroke={ink} strokeWidth="1.6" />
  const rsh = L.code === 'RSH'
  const cw = 105.5, rx = 98, ry = 1116, rh = 126

  return (
    <svg viewBox="0 0 920 1301" fill={ink} fontFamily="Arial, Helvetica, 'Liberation Sans', sans-serif" fontWeight="700" role="img" aria-label={`Shipping label ${L.awb}`}>
      {/* barcode */}
      {bc.bars.map(([bx, bw], i) => <rect key={i} x={107 + bx * mw} y="97" width={bw * mw} height="140" />)}
      <Tx x={290} y={262} s={24} a="middle">AWB {L.awb}</Tx>

      {/* ship to (address long hoy to wrap thay, right boxes sudhi nahi jay) */}
      <Tx x={83} y={303} s={25}>Ship To:</Tx>
      {L.to.flatMap(t => wrapText(t, 430, 22)).slice(0, 7).map((t, i) => (
        <Tx key={i} x={83} y={345 + i * 24.5} s={22}>{t}</Tx>
      ))}
      <Tx x={83} y={540} s={23}>Order Id: {inv.orderNo}</Tx>
      <Tx x={83} y={564} s={23}>Ship Date: {shipDate}</Tx>

      {/* right boxes */}
      {box(531, 80, 154, 75, 4, rsh ? ink : 'none')}
      <Tx x={608} y={133} s={fit(L.code, 138, 44)} a="middle" fill={rsh ? paper : undefined}>{L.code}</Tx>
      {L.flag?.length > 0 && <>
        {box(693, 78, 152, 68, 4)}
        <Tx x={769} y={105} s={25} a="middle">{L.flag[0]}</Tx>
        <Tx x={769} y={135} s={25} a="middle">{L.flag[1]}</Tx>
      </>}
      {box(531, 163, 154, 40)}<Tx x={608} y={192} s={27} a="middle">{L.weight} kgs</Tx>
      {box(531, 210, 154, 40)}
      {box(531, 259, 154, 68)}<Tx x={608} y={311} s={fit(L.due, 138, 38)} a="middle">{L.due}</Tx>
      {box(531, 334, 154, 68)}<Tx x={608} y={378} s={fit(L.pay, 138, 38)} a="middle">{L.pay}</Tx>
      {box(628, 409, 124, 45)}<Tx x={637} y={440} s={23}>{L.box || 'BOX 1 of 1'}</Tx>
      <Tx x={782} y={395} s={23} a="middle" rot>{L.vcode}</Tx>

      {/* station / sector / sortzone */}
      {box(475, 462, 146, 81)}<Tx x={497} y={486} s={14}>DELIVERY STATION</Tx><Tx x={497} y={533} s={fit(L.station, 114, 46)}>{L.station}</Tx>
      {box(628, 462, 120, 81, 3.5, ink)}<Tx x={650} y={486} s={15} fill={paper}>SECTOR</Tx><Tx x={650} y={533} s={fit(L.sector, 88, 46)} fill={paper}>{L.sector}</Tx>
      {box(754, 462, 123, 81)}<Tx x={776} y={486} s={15}>SORTZONE</Tx><Tx x={776} y={533} s={fit(sort, 91, 46)}>{sort}</Tx>
      {hl(574)}

      {/* 4 data-matrix codes */}
      {[0, 1, 2, 3].map(i => <DMock key={i} x={122 + i * 184.67} y={608} size={152} seed={inv.id + i} ink={ink} />)}

      {/* ship from */}
      {hl(776)}
      <Tx x={77} y={792} s={17}>Ship From: {SELLER.name}</Tx>
      <Tx x={77} y={809} s={13}>Return Address: PLOT NO 57, BHAYCHAND NAGAR SOCIETY, KATARGAM ROAD, Surat Surat</Tx>
      <Tx x={77} y={826} s={13}>GUJARAT 395004 India</Tx>
      {hl(842)}
      <Tx x={97} y={862} s={16}>Customer Self Declaration : The goods sold are intended for end user consumption. Not for resale.</Tx>

      {/* declaration table */}
      {[[80, 113, '#', '1'], [118, 243, 'SELLER', ''], [247, 420, 'GSTIN', SELLER.gst], [424, 563, 'INVOICE', inv.id], [567, 685, 'DATE', `${mm}-${dd}-${yy}`], [689, 877, 'ITEM TYPE', L.itemType]].map(([x1, x2, h, v]) => (
        <g key={h}>
          {box(x1, 874, x2 - x1, 34, 2.5)}{box(x1 + 3, 877, x2 - x1 - 6, 28, 0.8)}
          <Tx x={(x1 + x2) / 2} y={900} s={h === '#' ? 24 : 22} a="middle">{h}</Tx>
          {box(x1, 912, x2 - x1, 78, 2.5)}{box(x1 + 3, 915, x2 - x1 - 6, 72, 0.8)}
          <Tx x={x1 + 8} y={931} s={14}>{v}</Tx>
        </g>
      ))}

      {/* route box */}
      {box(rx, ry, cw * L.route.length, rh, 4.5)}
      {L.route.map((c, i) => {
        const x = rx + i * cw
        return (
          <g key={i}>
            {i > 0 && <line x1={x} x2={x} y1={ry} y2={ry + rh} stroke={ink} strokeWidth="3" />}
            <Tx x={x + 12} y={ry + 48} s={42}>{c.top}</Tx>
            {c.chip && <>
              <rect x={x + 8} y={ry + 68} width="26" height="44" fill={ink} />
              <Tx x={x + 21} y={ry + 100} s={34} a="middle" fill={paper}>{c.chip}</Tx>
              <Tx x={x + 40} y={ry + 105} s={40}>{c.code}</Tx>
            </>}
          </g>
        )
      })}

      <Tx x={91} y={1263} s={20}>Sold on: www.amazon.in</Tx>
      <Tx x={720} y={1272} s={33}>ATSPL</Tx>
    </svg>
  )
}

/** modal preview — selected template pramane */
function InvoicePages({ inv, template }) {
  if (template === '2') {
    return (
      <div className="ai-pages">
        <div className="ai-cap">Page 1 · Shipping label</div>
        <SupadaaLabelSheet inv={inv} />
        <div className="ai-cap">Page 2 · Tax invoice</div>
        <SupadaaInvoiceSheet inv={inv} />
      </div>
    )
  }
  return (
    <div className="ai-pages">
      <div className="ai-cap">Page 1 · Shipping label</div>
      <div className="lb-page"><LabelSheet inv={inv} /></div>
      <div className="ai-cap">Page 2 · Tax invoice</div>
      <InvoiceSheet inv={inv} />
    </div>
  )
}

/* ═══════════════════════════════════════════════════════════
   INVOICE CSS
   • Light = default (paper look)
   • Dark  = [data-theme='dark'] (or .dark) — only the CSS variables change
   (Template 2 nu CSS SD_CSS ma chhe — SupadaaInvoiceSheet.jsx)
═══════════════════════════════════════════════════════════ */

const INVOICE_CSS = `
.ai-sheet, .ai-sheet * { box-sizing: border-box; }
.ai-sheet {
  --ai-bg: #ffffff; --ai-text: #111111; --ai-line: #1f1f1f; --ai-soft: #6a6a6a; --ai-head: #cdcdcd;
  font-family: Arial, Helvetica, 'Liberation Sans', sans-serif;
  font-size: 12.5px; line-height: 1.5; text-align: left;
  color: var(--ai-text); background: var(--ai-bg);
  padding: 28px 32px 18px; border-radius: 10px; border: 1px solid var(--border, #d9d9d9);
  display: flex; flex-direction: column; aspect-ratio: 210 / 297;
}
[data-theme='dark'] .ai-sheet, .dark .ai-sheet, [data-theme='dark'] .lb-page, .dark .lb-page {
  --ai-bg: #0f1527; --ai-text: #eef1fb; --ai-line: #5a6590; --ai-soft: #8f99b9; --ai-head: #222c4b;
}
.ai-sheet b { font-weight: 700; }

.ai-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 70px; }
.ai-logo { display: flex; flex-direction: column; line-height: 1; }
.ai-logo-t { font-size: 42px; font-weight: 800; letter-spacing: -1.5px; }
.ai-logo-t i { font-style: normal; font-weight: 400; letter-spacing: -1px; }
.ai-logo svg { margin: -2px 0 0 54px; }
.ai-title { text-align: right; font-size: 15px; line-height: 1.35; }
.ai-title b, .ai-title span { display: block; font-size: 15px; }
.ai-title span { font-weight: 400; }

.ai-parties { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 22px; }
.ai-col { display: flex; flex-direction: column; justify-content: space-between; min-width: 0; }
.ai-right { text-align: right; }
.ai-blk { margin-bottom: 16px; overflow-wrap: anywhere; }
.ai-blk:last-child { margin-bottom: 0; }
.ai-gap { height: 14px; }
.ai-qr { width: 74px; height: 74px; margin-top: 4px; display: block; }

.ai-table-wrap { overflow-x: auto; }
.ai-table { width: 100%; min-width: 640px; border-collapse: collapse; font-size: 11.5px; }
.ai-table th, .ai-table td { border: 1px solid var(--ai-line); padding: 3px 6px; vertical-align: middle; }
.ai-table th { vertical-align: bottom; line-height: 1.2; }
.ai-table th { background: var(--ai-head); font-weight: 700; text-align: left; }
.ai-table td.num { text-align: left; font-family: 'Palatino Linotype', Georgia, 'Times New Roman', serif; font-size: 12px; }
.ai-table .ai-desc { min-width: 220px; vertical-align: top; }
.ai-table td.ai-desc > div { margin-top: 1px; }
.ai-stack { display: flex; flex-direction: column; gap: 22px; }
.ai-total td { font-weight: 700; border-top-width: 2px; border-left: none; border-right: none; }
.ai-total td:first-child { border-left: 1px solid var(--ai-line); }
.ai-total td:last-child { border-right: 1px solid var(--ai-line); }
.ai-total td:first-child { text-align: left; }

.ai-box { border: 1.5px solid var(--ai-line); border-top: none; }
.ai-words { padding: 6px 8px 8px; border-bottom: 1px solid var(--ai-line); display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
.ai-sign { padding: 8px 8px 6px; display: flex; flex-direction: column; align-items: flex-end; gap: 4px; font-size: 13px; }
.ai-rcm { margin-top: 3px; font-size: 12.5px; }

.ai-pay { display: grid; grid-template-columns: 2fr 1.4fr 1fr 1fr; border: 1px solid var(--ai-line); margin-top: 18px; font-size: 10.5px; }
.ai-pay > div { padding: 4px 6px; border-right: 1px solid var(--ai-line); overflow-wrap: anywhere; }
.ai-pay > div:last-child { border-right: none; }

.ai-footer { margin-top: auto; padding-top: 56px; text-align: center; color: var(--ai-soft); font-size: 8.5px; line-height: 1.9; }
.ai-footer .ai-page { text-align: right; margin-top: 4px; }

@media (max-width: 680px) {
  .ai-sheet { padding: 18px 14px 14px; aspect-ratio: auto; }
  .ai-head { flex-direction: column; margin-bottom: 24px; }
  .ai-title { text-align: left; }
  .ai-parties { grid-template-columns: 1fr; }
  .ai-right { text-align: left; }
  .ai-pay { grid-template-columns: 1fr 1fr; }
  .ai-pay > div { border-bottom: 1px solid var(--ai-line); }
}
.lb-page {
  --ai-bg: #ffffff; --ai-text: #111111; --ai-line: #1f1f1f; --ai-soft: #6a6a6a; --ai-head: #cdcdcd;
  background: var(--ai-bg); color: var(--ai-text); aspect-ratio: 210 / 297; overflow: hidden;
  border-radius: 10px; border: 1px solid var(--border, #d9d9d9);
}
.lb-page svg { display: block; width: 100%; height: 100%; }
.ai-pages { display: flex; flex-direction: column; gap: 10px; }
.ai-cap { font-size: 11px; font-weight: 600; color: var(--text3, #7a849f); margin: 6px 2px 0; }

/* template selector (view modal) */
.ai-tplbar { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 14px; }
.ai-tplbar label { font-size: 12px; font-weight: 600; color: var(--text2, #9aa3bd); }
.ai-tplbar .ai-tplsel { flex: 1; min-width: 240px; max-width: 420px; }

/* live amount summary (create / edit form) */
.ai-fsum { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 8px 16px; padding: 12px 14px;
  border: 1px dashed var(--border-active, var(--border)); border-radius: var(--radius-md, 10px); background: var(--bg-raised, transparent); }
.ai-fsum > div { display: flex; justify-content: space-between; gap: 10px; font-size: 12px; color: var(--text2, #9aa3bd); }
.ai-fsum b { color: var(--text1, inherit); }
.ai-fsum .ai-fsum-grand { grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid var(--border); font-weight: 700; }
`

/* print / PDF document → always light "paper" */
const PAPER_CSS = `
* { margin: 0; padding: 0; box-sizing: border-box; }
/* background colours (green header, panels, bar) print ma pan aave te mate */
*, *::before, *::after { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
html, body { background: #ffffff; color-scheme: light; }
.ai-paper { width: 860px; max-width: 100%; margin: 0 auto; }
.ai-paper .ai-sheet { border: none !important; border-radius: 0 !important; padding: 28px 32px 18px !important; }
.ai-paper .lb-page { border: none !important; border-radius: 0 !important; }
.ai-paper .sd-sheet { border: none !important; border-radius: 0 !important; }
@page { size: A4; margin: 8mm; }
@media print {
  .ai-paper { width: 100%; }
  .ai-paper > * + * { break-before: page; }
  /* Template 2: same layout as PDF (860px) fit thay A4 page ma, ek page = ek sheet */
  .ai-paper .sd-sheet { width: 860px; zoom: .84; margin: 0 auto; break-inside: avoid; }
}
`

/** selected template pramane print / PDF html banave */
function buildInvoiceHTML(inv, template = '1') {
  const body = template === '2'
    ? renderToStaticMarkup(<><SupadaaLabelSheet inv={inv} /><SupadaaInvoiceSheet inv={inv} /></>)
    : renderToStaticMarkup(<><div className="lb-page"><LabelSheet inv={inv} ink="#111111" paper="#ffffff" /></div><InvoiceSheet inv={inv} /></>)
  return `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${inv.id} - Tax Invoice</title>
<style>${INVOICE_CSS}${SD_CSS}${PAPER_CSS}</style>
</head><body><div class="ai-paper">${body}</div></body></html>`
}

/* ═══════════════════════════════════════════════════════════
   PAGE
═══════════════════════════════════════════════════════════ */
export default function Invoice() {
  const [invoices, setInvoices] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState('')
  const [saving, setSaving] = useState(false)
  const [formError, setFormError] = useState('')
  const [search, setSearch] = useState('')
  const [statusF, setStatusF] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [createOpen, setCreateOpen] = useState(false)
  const [viewOpen, setViewOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [active, setActive] = useState(null)
  const [form, setForm] = useState(blankForm())
  const [orderOptions, setOrderOptions] = useState([])
  /* NEW: product dropdown (manual invoice mate) */
  const [productOptions, setProductOptions] = useState([])
  const [productError, setProductError] = useState('')
  /* NEW: selected invoice template ('1' | '2') — yaad rakhe (localStorage) */
  const [template, setTemplate] = useState(readTemplate)

  const changeTemplate = v => {
    setTemplate(v)
    try { localStorage.setItem(TEMPLATE_KEY, v) } catch (e) { /* ignore */ }
  }

  /* ---------- load from API ---------- */
  const load = async () => {
    setLoading(true)
    setLoadError('')
    try {
      const res = await api('/invoices')
      setInvoices(res.data || [])
    } catch (e) {
      setLoadError(e.message)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => { load() }, [])

  /* ---------- orders dropdown (invoice haji nathi banyu te order items) ---------- */
  const loadOrders = async () => {
    try {
      const res = await api('/invoices/orders')
      setOrderOptions(res.data || [])
    } catch (e) {
      setOrderOptions([])
    }
  }

  /* ---------- products dropdown (active products) ---------- */
  /* product -> invoice fields (ex-tax MRP, discount, GST, HSN) — /products na data mathi */
  const productFill = p => {
    const rate = Number(p.gst_rate || 0)
    const inclusive = p.price_includes_tax !== false
    const factor = inclusive ? 1 / (1 + rate / 100) : 1
    const sell = Number(p.price) || 0
    const mrp = Number(p.old_price) > sell ? Number(p.old_price) : sell
    const unit = r2(mrp * factor)
    const net = r2(sell * factor)
    return {
      desc: [p.name, p.sku ? `SKU: ${p.sku}` : null].filter(Boolean).join(' | '),
      hsn: p.hsn_code || '3924',
      unitPrice: String(unit),
      qty: '1',
      discount: String(Math.max(0, r2(unit - net))),
      taxRate: String(Math.round(rate)),
      shippingCharge: '0',
    }
  }

  const loadProducts = async () => {
    setProductError('')
    /* 1) navo endpoint  2) na chale to admin /products (Product page vaprе chhe te j) */
    try {
      const res = await api('/invoices/products')
      const list = res.data || []
      if (list.length) { setProductOptions(list); return }
    } catch (e) { /* fallback par jao */ }
    try {
      const res = await api('/products')
      const list = (res.data || [])
        .filter(p => Number(p.status) === 1)
        .map(p => ({ value: p.id, label: p.sku ? `${p.name} (${p.sku})` : p.name, fill: productFill(p) }))
      setProductOptions(list)
      if (!list.length) setProductError('No active products found.')
    } catch (e) {
      setProductOptions([])
      setProductError('Could not load products: ' + e.message)
    }
  }

  /* order select thay tyare form na badha fields auto set */
  const pickOrder = v => {
    const o = orderOptions.find(x => String(x.value) === String(v))
    setForm(p => ({ ...p, orderItemId: v, productId: '', ...(o ? o.fill : { orderNo: '' }) }))
  }

  /* product select thay tyare description, HSN, MRP, discount, GST, qty auto set */
  const pickProduct = v => {
    const o = productOptions.find(x => String(x.value) === String(v))
    setForm(p => ({ ...p, productId: v, ...(o ? o.fill : {}) }))
  }

  const filtered = invoices.filter(i => {
    const q = search.toLowerCase()
    return (!q || i.customer.toLowerCase().includes(q) || i.id.toLowerCase().includes(q) || i.orderNo.includes(q)) &&
      (!statusF || i.status === statusF)
  })

  /* ---------- pagination ---------- */
  useEffect(() => { setPage(1) }, [search, statusF])

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize))
  const currentPage = Math.min(page, totalPages)
  const paginated = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  const handlePageSizeChange = size => { setPageSize(size); setPage(1) }

  const stats = [
    { label: 'Total Invoices', value: invoices.length, color: '#4F46E5', glow: 'rgba(79,70,229,.18)', variant: 'indigo', trend: '+18%' },
    { label: 'Paid', value: invoices.filter(i => i.status === 'paid').length, color: '#10B981', glow: 'rgba(16,185,129,.15)', variant: 'green', trend: '+12%' },
    { label: 'Pending', value: invoices.filter(i => i.status === 'pending').length, color: '#F59E0B', glow: 'rgba(245,158,11,.15)', variant: 'amber', trend: '+5%', dir: 'neutral' },
    { label: 'Overdue', value: invoices.filter(i => i.status === 'overdue').length, color: '#EF4444', glow: 'rgba(239,68,68,.15)', variant: 'red', trend: '-3%', dir: 'down' },
  ]

  const openAdd = () => { setActive(null); setForm(blankForm()); setFormError(''); setCreateOpen(true); loadOrders(); loadProducts() }
  const openEdit = inv => {
    setActive(inv)
    setForm({ ...blankForm(), ...inv.raw })
    setFormError('')
    setCreateOpen(true)
    if (!inv.raw?.orderItemId) loadProducts() // order sathe linked na hoy to product pick kari shake
  }
  const openView = inv => { setActive(inv); setViewOpen(true) }

  /* live amount summary (form ma) — invoice sheet jevi j calculation */
  const formSum = (() => {
    const unit = Number(form.unitPrice) || 0
    const qty = Number(form.qty) || 0
    const disc = Number(form.discount) || 0
    const rate = Number(form.taxRate) || 0
    const ship = Number(form.shippingCharge) || 0
    const gross = r2(unit * qty)
    const discount = r2(disc * qty)
    const net = r2(gross - discount)
    const tax = r2((net * rate) / 100)
    const total = r2(net + tax)
    return { gross, discount, net, tax, rate, total, ship, grand: r2(total + ship) }
  })()

  /* order thi banelo invoice: order na fields (customer, address, price, discount, GST, qty...) change na thay */
  const locked = !!form.orderItemId

  const save = async () => {
    if (!form.customer.trim() || form.unitPrice === '') {
      setFormError('Customer name and unit price are required.')
      return
    }
    setSaving(true)
    setFormError('')
    try {
      const res = await api(active ? '/invoices/update' : '/invoices/create', toPayload(form, active))
      const inv = res.data
      setInvoices(p => (active ? p.map(i => (i.db_id === active.db_id ? inv : i)) : [inv, ...p]))
      setCreateOpen(false)
      if (!active) loadOrders() // invoice banyu te order item list mathi nikdi jay
    } catch (e) {
      setFormError(e.message)
    } finally {
      setSaving(false)
    }
  }

  const confirmDelete = async () => {
    try {
      await api('/invoices/delete', { id: active.db_id })
      setInvoices(p => p.filter(i => i.db_id !== active.db_id))
    } catch (e) {
      alert(e.message)
    }
    setDeleteOpen(false)
    setActive(null)
  }

  const printInvoice = () => {
    if (!active) return
    const old = document.getElementById('__inv_print_frame')
    if (old) old.remove()
    const iframe = document.createElement('iframe')
    iframe.id = '__inv_print_frame'
    iframe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:960px;height:1px;border:none;visibility:hidden'
    document.body.appendChild(iframe)
    iframe.contentDocument.open()
    iframe.contentDocument.write(buildInvoiceHTML(active, template))
    iframe.contentDocument.close()
    setTimeout(() => {
      iframe.style.height = (iframe.contentDocument.body.scrollHeight + 40) + 'px'
      setTimeout(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
        setTimeout(() => iframe.remove(), 2000)
      }, 500)
    }, 600)
  }

  const downloadInvoice = async () => {
    if (!active) return
    const loadScript = src => new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) { resolve(); return }
      const s = document.createElement('script')
      s.src = src; s.onload = resolve; s.onerror = reject
      document.head.appendChild(s)
    })
    try {
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js')
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js')
      const RENDER_WIDTH = 860
      const iframe = document.createElement('iframe')
      iframe.style.cssText = `position:fixed;left:-9999px;top:0;width:${RENDER_WIDTH}px;height:3200px;border:none;visibility:hidden;z-index:-1`
      document.body.appendChild(iframe)
      iframe.contentDocument.open()
      iframe.contentDocument.write(buildInvoiceHTML(active, template))
      iframe.contentDocument.close()
      await new Promise(r => setTimeout(r, 1500))
      /* Template 1 => label + invoice (2 page), Template 2 => .sd-sheet (1 page) */
      const pages = [...iframe.contentDocument.querySelectorAll('.lb-page, .ai-sheet, .sd-sheet')]
      if (!pages.length) { document.body.removeChild(iframe); return }
      const { jsPDF } = window.jspdf
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true })
      for (let i = 0; i < pages.length; i++) {
        const canvas = await window.html2canvas(pages[i], {
          scale: 2.5, useCORS: true, allowTaint: true, backgroundColor: '#ffffff', logging: false,
          windowWidth: RENDER_WIDTH, windowHeight: iframe.contentDocument.documentElement.scrollHeight,
        })
        if (i > 0) pdf.addPage()
        let w = 210
        let h = (canvas.height * w) / canvas.width
        if (h > 297) { w = (canvas.width * 297) / canvas.height; h = 297 }
        pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', (210 - w) / 2, 0, w, h)
      }
      document.body.removeChild(iframe)
      pdf.save(`${active.id}-Invoice.pdf`)
    } catch (err) {
      console.error('PDF generation error:', err)
      const blob = new Blob([buildInvoiceHTML(active, template)], { type: 'text/html;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = `${active.id}-Invoice.html`; a.click()
      setTimeout(() => URL.revokeObjectURL(url), 3000)
    }
  }

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }))

  return (
    <div className="dash-page page-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--space-md)' }}>
        <h1 className="page-title">Invoices</h1>
        <button className="btn btn-primary" onClick={openAdd}><Plus size={14} /> Create Invoice</button>
      </div>

      <div className="stats-grid cols-4">
        {stats.map(s => (
          <div key={s.label} className={`stat-card stat-card--${s.variant}`}>
            <span style={{ position: 'absolute', top: 0, right: 0, width: 110, height: 110, borderRadius: '50%', background: s.glow, filter: 'blur(30px)', transform: 'translate(30%,-30%)', pointerEvents: 'none' }} />
            <div className="stat-card-header">
              <div className="stat-card-icon" style={{ background: s.glow, color: s.color, border: `1px solid ${s.glow}` }}><FileText size={15} strokeWidth={1.8} /></div>
              <span className={`stat-card-trend${s.dir === 'down' ? ' down' : s.dir === 'neutral' ? ' neutral' : ''}`} style={{ color: s.color, background: `${s.color}15`, border: `1px solid ${s.glow}` }}>{s.trend}</span>
            </div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-label">{s.label}</div>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg,${s.color}88,transparent)`, borderRadius: '0 0 var(--radius-lg) var(--radius-lg)' }} />
          </div>
        ))}
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', padding: 'var(--space-md) var(--space-lg)', borderBottom: '1px solid var(--border)', flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
            <Search size={13} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--text3)' }} />
            <input className="input" style={{ paddingLeft: 32 }} placeholder="Search invoice, customer or order no…" value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <Select
            style={{ width: 'auto', minWidth: 140 }}
            value={statusF}
            onChange={setStatusF}
            options={FILTER_STATUS_OPTIONS}
            ariaLabel="Filter by status"
          />
          <button className="btn btn-outline btn-sm" onClick={load}>Refresh</button>
        </div>
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr><th>Invoice</th><th>Customer</th><th>Amount</th><th>Status</th><th>Invoice Date</th><th>Order No.</th><th /></tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 28, color: 'var(--text3)' }}>Loading invoices…</td></tr>
              )}
              {!loading && loadError && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 28, color: '#EF4444' }}>{loadError}</td></tr>
              )}
              {!loading && !loadError && filtered.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 28, color: 'var(--text3)' }}>No invoices found</td></tr>
              )}
              {!loading && paginated.map(inv => {
                const sm = STATUS_META[inv.status] || STATUS_META.draft
                return (
                  <tr key={inv.db_id}>
                    <td><span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-xs)', color: 'var(--accent-hover)', fontWeight: 600 }}>{inv.id}</span></td>
                    <td>
                      <div style={{ fontWeight: 600, color: 'var(--text1)', fontSize: 'var(--fs-sm)' }}>{inv.customer}</div>
                      <div style={{ fontSize: 'var(--fs-xs)', color: 'var(--text3)' }}>{inv.delivery}</div>
                    </td>
                    <td style={{ fontWeight: 700, color: 'var(--text1)', fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-sm)' }}>{inr(calc(inv).total + Number(inv.shippingCharge || 0))}</td>
                    <td>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 99, fontSize: 11, fontWeight: 600, background: sm.bg, color: sm.color, border: `1px solid ${sm.border}` }}>
                        <span style={{ width: 5, height: 5, borderRadius: '50%', background: sm.color, display: 'inline-block' }} />
                        {sm.label}
                      </span>
                    </td>
                    <td style={{ color: 'var(--text3)', fontSize: 'var(--fs-xs)' }}>{inv.date}</td>
                    <td style={{ color: 'var(--text3)', fontSize: 'var(--fs-xs)', fontFamily: 'var(--font-mono)' }}>{inv.orderNo}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="btn btn-ghost btn-icon" onClick={() => openView(inv)} title="View"><Eye size={14} /></button>
                        <button className="btn btn-ghost btn-icon" onClick={() => openEdit(inv)} title="Edit"><Pencil size={14} /></button>
                        <button className="btn btn-ghost btn-icon" style={{ color: 'var(--color-red)' }} onClick={() => { setActive(inv); setDeleteOpen(true) }} title="Delete"><Trash2 size={14} /></button>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        {!loading && !loadError && filtered.length > 0 && (
          <Pagination
            total={filtered.length}
            page={currentPage}
            pageSize={pageSize}
            onPageChange={setPage}
            onPageSizeChange={handlePageSizeChange}
            pageSizeOptions={[10, 20, 50, 100]}
          />
        )}
      </div>

      {/* Create / Edit Modal */}
      <Modal
        open={createOpen}
        title={active ? 'Edit Invoice' : 'Create Invoice'}
        subtitle="Fill in the details to generate an invoice"
        onClose={() => setCreateOpen(false)}
        variant={active ? 'edit' : 'add'}
        footer={<>
          <button className="btn btn-outline" onClick={() => setCreateOpen(false)} disabled={saving}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? 'Saving…' : active ? 'Update Invoice' : 'Create Invoice'}
          </button>
        </>}
      >
        {formError && (
          <div style={{ marginBottom: 12, padding: '9px 12px', borderRadius: 8, fontSize: 12.5, fontWeight: 600, color: '#EF4444', background: 'rgba(239,68,68,.10)', border: '1px solid rgba(239,68,68,.30)' }}>
            {formError}
          </div>
        )}
        <div className="form-grid cols-2">
          {/* Order select: Create ma j. Order pick karo to niche na badha fields auto bharay */}
          {!active && (
            <div className="form-field full">
              <label>Select Order (optional)</label>
              <Select
                value={form.orderItemId}
                onChange={pickOrder}
                searchable
                placeholder="— Manual entry (no order) —"
                options={[
                  { value: '', label: '— Manual entry (no order) —' },
                  ...orderOptions.map(o => ({ value: String(o.value), label: o.label })),
                ]}
                ariaLabel="Select order"
              />
            </div>
          )}
          {!active && form.orderItemId && (
            <div className="form-field">
              <label>Order No.</label>
              <input className="input" value={form.orderNo} disabled />
            </div>
          )}

          {/* Product select: order select na karyo hoy tyare. Product pick karo to description, HSN, MRP, discount, GST auto bharay */}
          {!form.orderItemId && (
            <div className="form-field full">
              <label>Select Product (optional) <small style={{ color: 'var(--text3)' }}>— MRP, discount, GST and HSN are filled automatically</small></label>
              <Select
                value={form.productId}
                onChange={pickProduct}
                searchable
                placeholder="— Select product —"
                options={[
                  { value: '', label: '— Manual entry (no product) —' },
                  ...productOptions.map(o => ({ value: String(o.value), label: o.label })),
                ]}
                ariaLabel="Select product"
              />
              {productError && <small style={{ color: '#EF4444' }}>{productError}</small>}
            </div>
          )}

          {/* auto fields: Add ma hide, Edit ma disabled */}
          {active && (
            <>
              <div className="form-field">
                <label>Invoice No.</label>
                <input className="input" value={form.id} disabled />
              </div>
              <div className="form-field">
                <label>Order No.</label>
                <input className="input" value={form.orderNo} disabled />
              </div>
            </>
          )}
          <div className="form-field"><label>Customer Name</label><input className="input" placeholder="Customer name" value={form.customer} disabled={locked} onChange={e => f('customer', e.target.value)} /></div>
          <div className="form-field"><label>Phone</label><input className="input" placeholder="10-digit mobile number" value={form.phone} disabled={locked} onChange={e => f('phone', e.target.value)} /></div>
          <div className="form-field"><label>Invoice Date</label><input className="input" type="date" value={form.date} onChange={e => f('date', e.target.value)} /></div>
          <div className="form-field full"><label>Address</label><input className="input" placeholder="House no, street, area" value={form.addr} disabled={locked} onChange={e => f('addr', e.target.value)} /></div>
          <div className="form-field"><label>City</label><input className="input" placeholder="Surat" value={form.city} disabled={locked} onChange={e => f('city', e.target.value)} /></div>
          <div className="form-field"><label>Pincode</label><input className="input" placeholder="395004" value={form.pin} disabled={locked} onChange={e => f('pin', e.target.value)} /></div>
          <div className="form-field"><label>State</label>
            <div style={locked ? { pointerEvents: 'none', opacity: 0.6 } : undefined}>
              <Select value={form.state} onChange={v => f('state', v)} options={STATE_OPTIONS} searchable ariaLabel="State" disabled={locked} />
            </div>
          </div>
          <div className="form-field"><label>Customer GSTIN (optional)</label><input className="input" placeholder="07AAMPM9130B1ZU" value={form.gstin} onChange={e => f('gstin', e.target.value)} /></div>
          <div className="form-field full"><label>Product Description</label><textarea className="input" rows={2} placeholder="Product title | model | ASIN" value={form.desc} disabled={locked} onChange={e => f('desc', e.target.value)} /></div>
          <div className="form-field"><label>HSN</label><input className="input" value={form.hsn} disabled={locked} onChange={e => f('hsn', e.target.value)} /></div>
          <div className="form-field"><label>Unit Price / MRP, ex-tax (₹)</label><input className="input" type="number" placeholder="237.14" value={form.unitPrice} disabled={locked} onChange={e => f('unitPrice', e.target.value)} /></div>
          <div className="form-field"><label>Qty</label><input className="input" type="number" min="1" value={form.qty} disabled={locked} onChange={e => f('qty', e.target.value)} /></div>
          <div className="form-field"><label>Discount per unit (₹)</label><input className="input" type="number" value={form.discount} disabled={locked} onChange={e => f('discount', e.target.value)} /></div>
          <div className="form-field"><label>GST Rate</label>
            <div style={locked ? { pointerEvents: 'none', opacity: 0.6 } : undefined}>
              <Select value={String(form.taxRate)} onChange={v => f('taxRate', v)} options={GST_OPTIONS} ariaLabel="GST rate" disabled={locked} />
            </div>
          </div>
          <div className="form-field"><label>Shipping Charges (₹)</label><input className="input" type="number" min="0" value={form.shippingCharge} disabled={locked} onChange={e => f('shippingCharge', e.target.value)} /></div>
          <div className="form-field"><label>Parcel Weight (kg)</label><input className="input" type="number" step="0.01" value={form.weight} onChange={e => f('weight', e.target.value)} /></div>
          <div className="form-field"><label>Item Type (label)</label><input className="input" placeholder="HARDWARE_HINGE" value={form.itemType} onChange={e => f('itemType', e.target.value)} /></div>
          <div className="form-field"><label>Payment Mode (Txn ID auto)</label>
            <Select value={form.payMode} onChange={v => f('payMode', v)} options={PAY_OPTIONS} placeholder="— None / COD —" ariaLabel="Payment mode" />
          </div>
          <div className="form-field"><label>Status</label>
            <Select value={form.status} onChange={v => f('status', v)} options={STATUS_OPTIONS} ariaLabel="Invoice status" />
          </div>

          {/* live amount summary */}
          {formSum.gross > 0 && (
            <div className="form-field full">
              <div className="ai-fsum">
                <div><span>Gross (MRP × Qty)</span><b>{inr(formSum.gross)}</b></div>
                {formSum.discount > 0 && <div><span>Discount</span><b style={{ color: '#10B981' }}>−{inr(formSum.discount)}</b></div>}
                <div><span>Net amount</span><b>{inr(formSum.net)}</b></div>
                <div><span>GST @ {formSum.rate}%</span><b>{inr(formSum.tax)}</b></div>
                <div><span>Invoice total</span><b>{inr(formSum.total)}</b></div>
                {formSum.ship > 0 && <div><span>Shipping</span><b>{inr(formSum.ship)}</b></div>}
                <div className="ai-fsum-grand"><span>Customer pays</span><b>{inr(formSum.grand)}</b></div>
              </div>
            </div>
          )}
        </div>
      </Modal>

      {/* View Modal  (template selector + preview + print + PDF) */}
      <Modal
        open={viewOpen}
        title={active?.id || 'Invoice'}
        subtitle="Page 1 Shipping Label · Page 2 Tax Invoice"
        onClose={() => setViewOpen(false)}
        variant="edit"
        footer={<>
          <button className="btn btn-outline" onClick={() => setViewOpen(false)}>Close</button>
          <button className="btn btn-outline" style={{ color: '#818CF8', borderColor: 'rgba(79,70,229,.35)', background: 'rgba(79,70,229,.08)' }} onClick={printInvoice}>
            <Printer size={13} /> Print
          </button>
          <button className="btn btn-primary" onClick={downloadInvoice}>
            <Download size={13} /> Download PDF
          </button>
        </>}
      >
        {active && (
          <>
            <div className="ai-tplbar">
              <label>Invoice Template</label>
              <div className="ai-tplsel">
                <Select
                  value={template}
                  onChange={changeTemplate}
                  options={TEMPLATE_OPTIONS}
                  ariaLabel="Invoice template"
                />
              </div>
            </div>
            <InvoicePages inv={active} template={template} />
          </>
        )}
      </Modal>

      {/* Delete Modal */}
      <ConfirmModal
        open={deleteOpen}
        title="Delete Invoice"
        message={`Remove ${active?.id || 'this invoice'} permanently?`}
        onClose={() => setDeleteOpen(false)}
        onConfirm={confirmDelete}
      />

      <style>{`
        .dash-page { display:flex; flex-direction:column; gap:var(--space-lg); width:100%; }
        .modal-card { width: min(940px, 96vw) !important; }
        ${INVOICE_CSS}
        ${SD_CSS}
      `}</style>
    </div>
  )
}